function setComment(comment_id, type, type_id, comment, target){

	var token = $.getMeta('property','token');
	var parent_id = 0;
	
	
	var transData = {
		'_token' : token,
		'comment_id' : comment_id,		
		'type' : type,
		'type_id' : type_id,
		'comment' : comment,
		'parent_id' : parent_id
	}
	
	$.ajax({
	  type:'POST',							
	  url: "/post/comment/addComment/",
	  data:transData,
	  dataType: "json",
	  success: function(res){
  		switch(res.code){
	  		case 201:
	  			alert(res.message);
	  		break;
	  		case 100:
	  			$("#user-board-comment").val("");
	  			getComments(type, type_id, target);
	  		break;
  		}
	}});
}

function replyComment(type, type_id, parent_id, target){

	var token = $.getMeta('property','token');
	var comment = $(".input-comment-" + parent_id).val();

	var transData = {
		'_token' : token,
		'type' : type,
		'type_id' : type_id,
		'comment' : comment,
		'parent_id' : parent_id
	}
	
	console.log(transData);

	$.ajax({
	  type:'POST',							
	  url: "/post/comment/addComment/",
	  data:transData,
	  dataType: "json",
	  success: function(res){
  		switch(res.code){
	  		case 201:
	  			alert(res.message);
	  		break;
	  		case 100:
	  			getComments(type, type_id, target);	
					  			
	  		break;
  		}
	}});

}

function modifyComment(type, type_id, comment_id, btnsModify){
	var token = $.getMeta('property','token');
	var comment = $("#box-comment-" + comment_id + " .box-comment-text").html();
	
	var transData = {
		'_token' : token,
		'type' : type,
		'type_id' : type_id,
		'comment' : comment,
		'comment_id' : comment_id
	}
	
	console.log(transData);
	
	$.ajax({
	  type:'POST',							
	  url: "/post/comment/setComment/",
	  data:transData,
	  dataType: "json",
	  success: function(res){
  		switch(res.code){
	  		case 201:
	  			alert(res.message);
	  		break;
	  		case 100:
	  			//getComments(type, type_id, target);
	  			$("#box-comment-" + comment_id + " .box-comment-text").removeAttr('contenteditable');
	  			$(btnsModify).remove();
	  		break;
  		}
	}});
}

function getComments(type, type_id, target){
	setUserInfo();

	var token = $.getMeta('property','token');

	var transData = {
		'_token' : token,
		'type' : type,
		'type_id' : type_id
	}

	$.ajax({
	  type:'POST',		
	  url: '/post/comment/getComments',
	  data : transData,
	  dataType: "json",
	  success: function(data){
		  
		var commentCnt = data.length;
		var commentsHtml = createComments(data);
		
		commentsHtml = $.parseHTML(commentsHtml);
		
		$(commentsHtml).find('.btn-response-comment').click(function(){

			var comment_id = $(this).attr("data-comment-id");
			
			var responseBoxHtml = "<div id='box-reply-comment-" + comment_id + "' class='col-xs-10 fr' style='margin-bottom:10px;'>";
				responseBoxHtml += "<div class=''>";
				responseBoxHtml += "<div class=' blank'>";
				responseBoxHtml += "<div class='status-upload'>";
				responseBoxHtml += "<div>";
				responseBoxHtml += "<textarea id='' class='input-comment-" + comment_id + "' placeholder='소중한 댓글을 입력해주세요.'></textarea>";
				responseBoxHtml += "</div>";
				responseBoxHtml += "<div class='fr' style='padding:5px;'>";
				responseBoxHtml += "<div class='btn-reply-comment-apply btn-xs btn-primary fr'>댓글 달기</div>";
				responseBoxHtml += "<div class='btn-reply-comment-cancel btn-xs btn-warning fr mr'>취소</div>";
				responseBoxHtml += "<div class='cr'></div>";				
				responseBoxHtml += "</div>";
				responseBoxHtml += "<div class='cr'></div>";					
				responseBoxHtml += "</div>";
				responseBoxHtml += "</div>";
				responseBoxHtml += "</div>";
				responseBoxHtml += "</div>";
				responseBoxHtml += "<div class='cr'></div>";
				
			if($("#box-reply-comment-" + comment_id).length == 0){
				
				responseBoxHtml = $.parseHTML(responseBoxHtml);
				$(responseBoxHtml).find(".btn-reply-comment-apply").click(function(){
					replyComment(type, type_id, comment_id, target);
				});

				$(responseBoxHtml).find(".btn-reply-comment-cancel").click(function(){
					$(responseBoxHtml).remove();
				});
				console.log(comment_id);
				$(responseBoxHtml).insertAfter("#box-comment-" + comment_id).hide().slideDown(150);;	
			}

		});

		$(commentsHtml).find('.btn-del-comment').click(function(){
			var comment_id = $(this).attr("data-comment-id");
			if (confirm('댓글을 삭제하시겠습니까?')) {
			    delComment(type, type_id, comment_id);
			}
		});
		
		$(commentsHtml).find('.btn-modify-comment').click(function(){
			var comment_id = $(this).attr("data-comment-id");
			var comment = $("#box-comment-" + comment_id + " .box-comment-text").attr('contenteditable','true');
			var tmpComment = $("#box-comment-" + comment_id + " .box-comment-text").html();
			$("#box-comment-" + comment_id + " .box-comment-text").focus();
			var btnsModify = "<div class='fr' style='position:absolute;right:0px;right:10px;margin-top: -29px;'><div class='fr btn-xs btn-warning btn-comment-modify-cancel' >취소</div><div class='fr mr btn-xs btn-primary btn-comment-modify-apply' >적용</div><div class='cr'></div><div class='cr'></div>";
			btnsModify = $.parseHTML(btnsModify);

			$(btnsModify).find('.btn-comment-modify-cancel').click(function(){
				console.log(tmpComment);
				$("#box-comment-" + comment_id + " .box-comment-text").html(tmpComment);				
				$("#box-comment-" + comment_id + " .box-comment-text").removeAttr('contenteditable');
				$(btnsModify).remove();
			});
			$(btnsModify).find('.btn-comment-modify-apply').click(function(){
				if (confirm('댓글을 수정 하시겠습니까?')) {
				    modifyComment(type, type_id, comment_id, btnsModify);
				}
			});

			$("#box-comment-" + comment_id + " .box-comment-text").after(btnsModify);
			

			
		});		

		$(target).html(commentsHtml);
	  }
	});
}

function createComments(data){
	var commentsHtml = "";
	var cntComment = 0;

	$.each(data, function(idx, val){
		console.log(val.children);
		cntComment++;		
		var comment = makeCommentBox(val);
		commentsHtml += comment;

		if(typeof val.children == "object"){
			if (typeof val.children[0] !== 'undefined') {			
				cntComment++;
				commentsHtml += createComments(val.children);
			}
		}
	});
	
	$("#cnt-comment").html(cntComment);
	return commentsHtml;
}

function delComment(type, type_id, comment_id){
	var token = $.getMeta('property','token');
	var post_id = $.getMeta('name','post:id');
		
	var transData = {
		'_token' : token,
		'type' : type,
		'type_id' : type_id,
		'comment_id' : comment_id
	}
	
	$.ajax({
	  type:'POST',		
	  url: '/post/comment/delComment',
	  data : transData,
	  dataType: "json",
	  success: function(data){
		  //console.log(data);
		  //getComments();
		  $("#box-comment-" + comment_id).remove();
		}
	});
}

function makeCommentBox(commentInfo){
	
	if(commentInfo.timecreated != null){
		if(commentInfo.timemodified != null){
			var date = TimeAgoModified.inWords(commentInfo.timemodified);
		}else{
			var date = TimeAgo.inWords(commentInfo.timecreated);	
		}
		
	}
	
	var commentBox = "<div id='box-comment-" + commentInfo.id + "' class='col-xs-12 level-" + commentInfo.level + " box-comment'>"
		commentBox += "<div class='col-xs-1 comment-user-image'>";
		commentBox += "<div class='user-thumbnail'>";
		commentBox += "<img class='img-circle img-responsive user-photo' src='http://csms.ssu.coursemos.co.kr/user/pix.php/" + commentInfo.userInfo.id + "/f1.jpg'>"; 
		commentBox += "</div>";
		commentBox += "</div>";
		commentBox += "<div class='col-xs-11'>";
		commentBox += "<div class='panel panel-default'>";
		commentBox += "<div class='panel-heading'>";
		commentBox += "<div class='fl'> <strong>" + commentInfo.userInfo.firstname + "</strong></div>";
		if(uuid == commentInfo.userInfo.id){
			commentBox += "<div class='fr'><span class='btn-modify-comment btn-comment' data-comment-id='" + commentInfo.id + "'>수정</span> · <span class='btn-del-comment btn-comment' data-comment-id='" + commentInfo.id + "'>삭제</span></div>";
		}

		commentBox += "<div class='cr'></div>";	
		commentBox += "</div>";		
		
		commentBox += "<div class='box-comment-text panel-body'>";
		commentBox += commentInfo.comment;
		commentBox += "</div>";
		if(commentInfo.timecreated != null){
			commentBox += "<div class='panel-body'>";
			commentBox += "<div class=''> <!--<span>좋아요</span> · --><span class='btn-response-comment btn-comment' data-comment-id='" + commentInfo.id + "'>답글 달기</span> · <span class='text-muted'>" + date + "</span></div>";
			commentBox += "</div>";
		}
		
		commentBox += "</div>";
		commentBox += "</div>";
		commentBox += "</div>";

	return commentBox;
}

var TimeAgo = (function() {
  var self = {};
  
  // Public Methods
  self.locales = {
    prefix: '',
    sufix:  '전',
    
    seconds: '방금',
    minute:  '약 1분',
    minutes: '%d분',
    hour:    '약 한 시간',
    hours:   '약 %d 시간',
    day:     '하루',
    days:    '%d 일',
    month:   '약 한달',
    months:  '%d달',
    year:    '약 1년',
    years:   '%d년'
  };
  
  self.inWords = function(timeAgo) {
	
    var seconds = Math.floor((new Date()/ 1000) - parseInt(timeAgo) ),
        separator = this.locales.separator || ' ',
        words = this.locales.prefix + separator,
        interval = 0,
        intervals = {
          year:   seconds / 31536000,
          month:  seconds / 2592000,
          day:    seconds / 86400,
          hour:   seconds / 3600,
          minute: seconds / 60
        };
        
    var distance = this.locales.seconds;
    
    for (var key in intervals) {
      interval = Math.floor(intervals[key]);
      
      if (interval > 1) {
        distance = this.locales[key + 's'];
        break;
      } else if (interval === 1) {
        distance = this.locales[key];
        break;
      }
    }
    
    distance = distance.replace(/%d/i, interval);
    words += distance + separator + this.locales.sufix;

    return words.trim();
  };
  
  return self;
}());

var TimeAgoModified = (function() {
  var self = {};
  
  // Public Methods
  self.locales = {
    prefix: '',
    sufix:  '전 수정됨',
    
    seconds: '방금',
    minute:  '약 1분',
    minutes: '%d분',
    hour:    '약 한 시간',
    hours:   '약 %d 시간',
    day:     '하루',
    days:    '%d 일',
    month:   '약 한달',
    months:  '%d달',
    year:    '약 1년',
    years:   '%d년'
  };
  
  self.inWords = function(timeAgo) {
	
    var seconds = Math.floor((new Date()/ 1000) - parseInt(timeAgo) ),
        separator = this.locales.separator || ' ',
        words = this.locales.prefix + separator,
        interval = 0,
        intervals = {
          year:   seconds / 31536000,
          month:  seconds / 2592000,
          day:    seconds / 86400,
          hour:   seconds / 3600,
          minute: seconds / 60
        };
        
    var distance = this.locales.seconds;
    
    for (var key in intervals) {
      interval = Math.floor(intervals[key]);
      
      if (interval > 1) {
        distance = this.locales[key + 's'];
        break;
      } else if (interval === 1) {
        distance = this.locales[key];
        break;
      }
    }
    
    distance = distance.replace(/%d/i, interval);
    words += distance + separator + this.locales.sufix;

    return words.trim();
  };
  
  return self;
}());

function timeConverter(timestamp){
  var a = new Date(timestamp * 1000);
  var year = a.getFullYear();
  var month = a.getMonth();
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  
  var time = year + " - " + ("0" + month).slice(-2) + " - " + ("0" + date).slice(-2) + ' ( ' + ("0" + hour).slice(-2) + ':' + ("0" + min).slice(-2) + ':' + ("0" + sec).slice(-2)  + ' )' ;
  return time;
}